import { aktivnostTerminalaService } from '../services/a09-terminal-service';

const initialState = {
   aktivnostTerminala: []
};

export const ucitajAktivnostiTerminala = () => async (dispatch, getState) => {
   try {
      const statickiPodaci = await aktivnostTerminalaService.staticData();
      const { aktivnost } = statickiPodaci;

      const payload = {
         aktivnost
      };

      dispatch({ type: 'UCITAJ_AKTIVNOSTI_TERMINALA', payload });
   } catch (ex) {
      if (ex && ex.response && ex.response.status === 400) {
         const payload = {
            error: ex.response.data.Message
         };
      }
   }
};

//  REDUCER
export default function reducer(state = initialState, action) {
   switch (action.type) {
      case 'UCITAJ_AKTIVNOSTI_TERMINALA':
         const { aktivnost } = action.payload;
         return { ...state, aktivnostTerminala: aktivnost };
      default:
         return state;
   }
}
